import Button from "@mui/material/Button";
import * as React from "react";
import API from "@/api/serverCall";
import { applicationInfoType } from "types/app";
import { useSnackbar } from "notistack";

interface IDeleteButtonProps {
	setEditAppName: (value: string) => void;
	appObjectName: string;
	editAppName: string;
	appObjectId: number;
	setOpenEditAppComponent: (value: boolean) => void;
}

const EditAppComponent: React.FC<IDeleteButtonProps> = ({
	setEditAppName,
	appObjectName,
	editAppName,
	appObjectId,
	setOpenEditAppComponent,
}) => {
	const { enqueueSnackbar } = useSnackbar();
	const EditAppFunc = (appInfo: string) => {
		try {
			if (appInfo !== "") {
				const requestData = {
					name: appInfo,
					id: appObjectId,
					packageAndroid: "",
					packageIos: "",
				};

				API.PATCH<applicationInfoType>({
					link: `/app`,
					body: requestData,
				}).then((response) => {
					setEditAppName(response.data.name);
					setOpenEditAppComponent(false);
					enqueueSnackbar("앱 이름이 변경되었습니다", {
						variant: "info",
					});
				});
			}
		} catch (error) {
			console.error(error);
		}
	};
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "flex-end",
				paddingRight: "1.5rem",
				marginBottom: "1rem",
			}}
		>
			<Button
				variant="outlined"
				sx={{
					color: "#747474",
					borderColor: "#CCCCCC",
					marginRight: "0.5rem",
				}}
				onClick={() => {
					setEditAppName(appObjectName);
					setOpenEditAppComponent(false);
				}}
			>
				취소
			</Button>
			<Button
				variant="contained"
				sx={{ backgroundColor: "#2453F9", color: "white" }}
				onClick={() => {
					EditAppFunc(editAppName);
				}}
			>
				변경
			</Button>
		</div>
	);
};
export default EditAppComponent;
